import React from 'react';
import { motion } from 'framer-motion';
export function DirectMessage() {
  return <section className="py-24 md:py-32 px-6 bg-[#FAF8F5]" data-id="element-47">
      <div className="max-w-2xl mx-auto" data-id="element-48">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-[#E5E0D8]" data-id="element-49">
          <h2 className="text-2xl md:text-3xl font-serif text-[#2D2A26] mb-8 text-center" data-id="element-50">
            Mensaje directo (sin endulzar)
          </h2>

          <p className="text-lg md:text-xl text-[#4D4A46] mb-10 text-center leading-relaxed" data-id="element-51">
            No te puedo prometer que en 30 días nunca sentirás ansiedad.
          </p>

          <div className="space-y-5 text-center" data-id="element-52">
            <p className="text-xl md:text-2xl font-medium text-[#C4956A]" data-id="element-53">
              Sí puedo prometerte algo más útil:
            </p>
            <div className="space-y-4 text-lg md:text-xl font-medium text-[#2D2A26] leading-relaxed" data-id="element-54">
              <p data-id="element-55">Vas a dejar de estar a ciegas.</p>
              <p data-id="element-56">Vas a tener herramientas concretas para el momento crítico.</p>
              <p data-id="element-57">
                Y vas a tener un plan para sostenerte, incluso si tienes días
                malos.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}